export default __webpack_public_path__ + "js/components/common/unlock-button-font-pally/cta-hover-bg-94627073cc90d09f8a463bb7afc0198f.svg";